export default __webpack_public_path__ + "static/media/money-back.b3c6278c.png";